import jwt_decode from "jwt-decode";

// action
import {
    apiError,
    loginSuccess
} from "./reducer";

import {
    postJwtLogin,
} from "../../../helpers/fakebackend_helper";

export const loginUser = (user: any, history: any) => async (dispatch: any) => {
    try {
    let response: any;
       if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {

            response = postJwtLogin({
                username: user.email,
                password: user.password
            });

        }
        const data = await response;

        if (data) {
            const decoded: any = jwt_decode(data.access_token);
            const claims = decoded["https://hasura.io/jwt/claims"];
            if (claims["x-hasura-default-role"] === "reseller") {
                localStorage.setItem("authUser", JSON.stringify(data));
                localStorage.setItem("access_token", JSON.stringify(data.access_token));
                localStorage.setItem("user_id", claims["x-hasura-msgbox-id"]);
                dispatch(loginSuccess(data));
                history.push("/sales");
            } else {
                dispatch(apiError("Invalid credentials"));
            }
        }
    } catch (error) {
        console.log("errorr:", error);
        dispatch(apiError("Invalid credentials"));
    }
};

export const logoutUser = (history: any) => async (dispatch: any) => {
    try {
        localStorage.removeItem("authUser");

        history.push("/login");
    } catch (error) {
        dispatch(apiError(error));
    }
};